import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CartProp from '../../propTypes/CartProp';
import PackProp from '../../propTypes/PackProp';
import CategoryProp from '../../propTypes/CategoryProp';
import translate from '../../../../commonComponents/translate';
import Pack from './pack/Pack';
import ProductCategory from './category/ProductCategory';
import {
  PRODUCT_TYPE,
  PRODUCT_VIEW,
} from '../../../../services/utilityFunctions';
import ProductItemModal from './category/modal/ProductItemModal';

function BasicFeatures({
  t,
  nextStep,
  previousStep,
  cart,
  packs,
  onPackAdd,
  onPackRemove,
  categories,
  isEdit,
  interval,
  currentUserStats,
  onProductAdd,
  onProductRemove,
  onSubscriptionAdd,
  onSubscriptionRemove,
  onNavigate,
  hasPermissionToChange,
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleItemAdd = addInfo => {
    if (
      addInfo.product.type === PRODUCT_TYPE.SUBSCRIPTION ||
      addInfo.product.type === PRODUCT_TYPE.PREMIUM_SUBSCRIPTION
    ) {
      onSubscriptionAdd({
        ...addInfo,
        interval: addInfo.product.interval,
      });
    } else {
      onProductAdd({
        ...addInfo,
        interval: addInfo.product.interval,
      });
    }
    setSelectedProduct({ ...addInfo.product, isInCart: true });
  };

  const handleItemRemove = product => {
    if (
      product.type === PRODUCT_TYPE.SUBSCRIPTION ||
      product.type === PRODUCT_TYPE.PREMIUM_SUBSCRIPTION
    ) {
      onSubscriptionRemove(product._id);
    } else {
      onProductRemove(product._id);
    }
    setSelectedProduct({ ...product, isInCart: false });
  };

  const validateAndLeave = nextStepView => {
    onNavigate({}, nextStepView, true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  const openModal = product => {
    setShowModal(true);
    setSelectedProduct(product);
  };

  const { plan: selectedPlan } = cart;

  return (
    <>
      {showModal && (
        <ProductItemModal
          onClose={closeModal}
          onClickAdd={handleItemAdd}
          onClickRemove={handleItemRemove}
          product={selectedProduct}
          interval={interval}
          currentUserStats={currentUserStats}
          selectedPlan={selectedPlan}
          cart={cart}
          hasPermissionToChange={hasPermissionToChange}
        />
      )}
      <div style={{ padding: '20px' }}>
        <div className="row">
          <div className="col-12">
            {packs.length > 0 && (
              <h3 className="subscription-options-title">
                {t('subscriptionCreate_options_packs')}
              </h3>
            )}
            <div className="subscription-packs-container">
              {packs.map(p => {
                const isInCart = !!cart.packs.find(
                  ({ product }) => product._id === p._id,
                );

                return (
                  <Pack
                    key={p._id}
                    pack={p}
                    isSubscriptionEdit={isEdit}
                    isInCart={isInCart}
                    onAdd={onPackAdd}
                    onRemove={onPackRemove}
                    onOpenModal={openModal}
                    interval={interval}
                    hasPermissionToChange={hasPermissionToChange}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="subscription-trophies-container">
          {categories
            .filter(c => c.displayOnView === PRODUCT_VIEW.BASIC_FEATURES)
            .map(c => (
              <div className="m--margin-top-30" key={c._id}>
                <ProductCategory
                  name={c.name}
                  cart={cart}
                  products={c.products}
                  onClickAddItem={handleItemAdd}
                  onClickRemoveItem={handleItemRemove}
                  isSubscriptionEdit={isEdit}
                  onOpenDescriptionModal={openModal}
                  interval={interval}
                  selectedPlan={selectedPlan}
                  hasPermissionToChange={hasPermissionToChange}
                />
              </div>
            ))}
        </div>
      </div>
      <div className="wizard-content-footer">
        <button
          onClick={() => validateAndLeave(previousStep)}
          type="submit"
          className={
            'btn m-btn--pill m-btn--air' +
            ' btn-outline-primary m-btn m-btn--custom wizard-footer-btn'
          }
        >
          {`< ${t('previous')}`}
        </button>
        <button
          onClick={() => validateAndLeave(nextStep)}
          type="submit"
          className={
            'btn m-btn--pill m-btn--air btn-primary' +
            ' m-btn m-btn--custom wizard-footer-btn'
          }
        >
          {`${t('next')} >`}
        </button>
      </div>
    </>
  );
}

BasicFeatures.propTypes = {
  t: PropTypes.func.isRequired,
  nextStep: PropTypes.number.isRequired,
  previousStep: PropTypes.number.isRequired,
  cart: PropTypes.shape(CartProp.propType).isRequired,
  packs: PropTypes.arrayOf(PropTypes.shape(PackProp.propType)).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  onPackAdd: PropTypes.func.isRequired,
  onPackRemove: PropTypes.func.isRequired,
  onProductAdd: PropTypes.func.isRequired,
  onProductRemove: PropTypes.func.isRequired,
  onSubscriptionAdd: PropTypes.func.isRequired,
  onSubscriptionRemove: PropTypes.func.isRequired,
  onNavigate: PropTypes.func,
  isEdit: PropTypes.bool.isRequired,
  interval: PropTypes.string.isRequired,
  currentUserStats: PropTypes.shape({
    totalUsers: PropTypes.number,
    totalAdmins: PropTypes.number,
  }).isRequired,
  hasPermissionToChange: PropTypes.bool.isRequired,
};

BasicFeatures.defaultProps = {
  onNavigate: () => null,
};

export default translate(BasicFeatures);
